import { SET_RESOURCES_IN_PLACE, SET_CODES_IN_PLACE, SET_LEVEL_IN_THE_WIDGET } from "./types";

const WidgetResourcesInPlaceReducer = (state, action) => {
    const { type, payload } = action;
    switch (type) {
        case SET_RESOURCES_IN_PLACE:
            return {
                ...state,
                resources: payload.resources,
                codesTofilter: payload.codesTofilter,
                entitySelected: payload.entitySelected,
                levelSelected: payload.levelSelected,
                isFetching: false,
                error: payload.error
            }
        case SET_CODES_IN_PLACE:
            return {
                ...state,
                codesTofilter: payload,
            }
        case SET_LEVEL_IN_THE_WIDGET:
            return {
                ...state,
                levelSelected: payload,
            }
        default:
            return state;
    }
}

export default WidgetResourcesInPlaceReducer